import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import * as React from 'react';
import { FontUpgrade } from 'wix-style-react';
import { Language, Template, Theme } from '../../enums';

export const PageModeContext = React.createContext({
  theme: Theme.AdvancedPlans,
  template: Template.Grid,
  isFontUpgradeActive: true,
});

export const usePageModeContext = () => React.useContext(PageModeContext);

interface PageModeProviderProps extends InjectedExperimentsProps {
  theme: Theme;
  template: Template;
  locale: string;
}

const PageModeProviderComp: React.FC<PageModeProviderProps> = ({
  children,
  theme,
  template,
  locale,
}) => {
  const isFontUpgradeActive = locale !== Language.RU && locale !== Language.UK;
  return (
    <PageModeContext.Provider value={{ theme, template, isFontUpgradeActive }}>
      <FontUpgrade active={isFontUpgradeActive}>{children}</FontUpgrade>
    </PageModeContext.Provider>
  );
};

export const PageModeProvider = withExperiments(PageModeProviderComp);
